import { CSSProperties } from 'react';
import { ButtonView, LoadIndicatorView } from '@vivli/shared/views';
import { Color } from '@vivli/shared/theme';
import { DTICommonConst } from '@vivli/shared/infrastructure/constants';

const buttonWrapperStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-start',
    paddingTop: '20px',
};

const cancelBtnStyle: CSSProperties = { marginLeft: '10px', backgroundColor: Color.VIVLI_RED };

interface TeamMemberModalButtonsComponentProps {
    onCancel: () => void;
    onSave: () => void;
    onDelete?: () => void;
    isLoading?: boolean;
    showSaveButton?: boolean;
    showDeleteButton?: boolean;
}

export const TeamMemberModalButtonsComponent = ({
    onCancel,
    onSave,
    onDelete,
    isLoading,
    showSaveButton = true,
    showDeleteButton,
}: TeamMemberModalButtonsComponentProps) => {
    //note that the onSave here and all the way up only saves to the FORM,
    //and any research team changes this button save is preserving
    //only go to the server when
    //the entire Data Request FORM is updated, via Save button or
    //auto-save on tab change or Submit
    //the same goes for Remove  button
    return (
        <div style={buttonWrapperStyle}>
            <ButtonView
                disabled={isLoading}
                onClick={() => {
                    onCancel && onCancel();
                }}
                style={cancelBtnStyle}
            >
                Cancel
            </ButtonView>

            {showSaveButton && (
                <ButtonView onClick={onSave} dataId={DTICommonConst.OkButton} style={{ marginLeft: '10px' }}>
                    {isLoading ? <LoadIndicatorView /> : 'OK'}
                </ButtonView>
            )}
            {showDeleteButton && (
                <ButtonView onClick={onDelete} dataId={DTICommonConst.RemoveButton}>
                    {isLoading ? <LoadIndicatorView /> : 'Remove'}
                </ButtonView>
            )}
        </div>
    );
};
